module.exports = __webpack_public_path__ + "img/a3.38a7e5cd.svg";